import { heroImage } from '../data/copy'

const TITLE =
  'Ballet Teacher Elite System — 6 Master Volumes + 7 Bonuses for $27'
const DESCRIPTION =
  'Stop planning from scratch. 6 master volumes and 7 strategic bonuses of ready-to-teach ballet lesson plans for ages 3–16. Instant access, 7-day guarantee.'
const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Inter:wght@400;500;600&display=swap'

function upsertMeta(
  attribute: 'name' | 'property',
  key: string,
  content: string,
): void {
  let tag = document.head.querySelector<HTMLMetaElement>(
    `meta[${attribute}="${key}"]`,
  )
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attribute, key)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function upsertLink(
  rel: string,
  href: string,
  extra: Record<string, string> = {},
): HTMLLinkElement | null {
  if (document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) {
    return null
  }
  const link = document.createElement('link')
  link.rel = rel
  link.href = href
  Object.entries(extra).forEach(([name, value]) =>
    link.setAttribute(name, value),
  )
  document.head.appendChild(link)
  return link
}

/**
 * Runs before React renders: discovers the LCP image as early as possible,
 * warms up connections, loads fonts without blocking paint, and sets SEO tags.
 */
export function setupHead(): void {
  if (typeof document === 'undefined') return

  document.documentElement.lang = 'en'
  document.title = TITLE

  upsertLink('preconnect', 'https://cdn.magicpatterns.com')
  upsertLink('preload', heroImage, { as: 'image', fetchpriority: 'high' })

  upsertLink('preconnect', 'https://fonts.googleapis.com')
  upsertLink('preconnect', 'https://fonts.gstatic.com', {
    crossorigin: 'anonymous',
  })

  // Fetched at low priority, then promoted so it never blocks first paint.
  const fontLink = upsertLink('stylesheet', FONT_HREF, { media: 'print' })
  if (fontLink) {
    fontLink.addEventListener('load', () => {
      fontLink.media = 'all'
    })
  }

  upsertMeta('name', 'description', DESCRIPTION)
  upsertMeta('name', 'theme-color', '#FDF7F4')
  upsertMeta('property', 'og:title', TITLE)
  upsertMeta('property', 'og:description', DESCRIPTION)
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:image', heroImage)
  upsertMeta('name', 'twitter:card', 'summary_large_image')
}
